import 'slick-carousel';
//トップページ　キービジュアルスライダー
export function idxFunc() {
  if ($('#index').length) {
    $('.jsVoice').slick({
      autoplay: true,
      arrows: false,
      dots: false,
      infinite: true,
      variableWidth: true,
      centerMode: true,
      focusOnSelect: true,
      centerPadding: "0px",
      slidesToShow: 1,
      cssEase: 'linear',
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            infinite: true,
            variableWidth: true,
            centerMode: true,
            focusOnSelect: true,
            centerPadding: "0",
            slidesToShow: 1,
          },
      },
    ],
    });
  }
}